import { Grid, Slider, Typography } from '@mui/material';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import tripsService from '../../../services/trips.service';
interface PickupTimeWindowSelectorProps {
  shipperPickupTimeWindow?: [string, string];
  routingAttributes: any;
  date: string;
}
function PickupTimeWindowSelector({ routingAttributes, date }: PickupTimeWindowSelectorProps) {
  const [pickupTimewindow, setPickupTimewindow] = useState<[string, string]>(
    routingAttributes?.current?.pickupTimewindow ?? [
      moment(date).add(90, 'minutes').startOf('hour').format('HH:mm'),
      moment(date).add(150, 'minutes').startOf('hour').format('HH:mm'),
    ],
  );
  useEffect(() => {
    if (routingAttributes) {
      tripsService
        .getPickupTimeWindow(date)
        .then((timewindow) => {
          routingAttributes.current.pickupTimewindow = timewindow;
          setPickupTimewindow([timewindow[0], timewindow[1]]);
        })
        .catch(() => {
          const start = moment().add(30, 'minutes').startOf('hour').format('HH:mm');
          const end = moment().endOf('day').startOf('minute').format('HH:mm');
          routingAttributes.current.pickupTimewindow = [start, end];
          setPickupTimewindow([start, end]);
          console.log(routingAttributes.current.pickupTimewindow);
        });
    }
  }, [routingAttributes, date]);
  const timeToFloat = (time: string) => {
    const parts = time.split(':');
    return +parts[0] + +parts[1] / 60;
  };
  const floatToTime = (val: number, is12h: boolean = false) => {
    let h = Math.floor(val);
    const m = (val - h) * 60;
    const ampm = is12h ? (h >= 12 ? 'pm' : 'am') : '';
    if (is12h && h > 12) {
      h = h - 12;
    }
    const str = is12h
      ? `${h.toString()}:${m.toFixed(0).padStart(2, '0')} ${ampm}`
      : `${h.toString().padStart(2, '0')}:${m.toFixed(0).padStart(2, '0')}`;
    return str;
  };
  const changePickupTimewindow = (from?: string, to?: string) => {
    const startDate = moment(`${date} ${from ?? pickupTimewindow[0]}`, 'YYYY-MM-DD HH:mm');
    // if (startDate.isBefore(moment())) return;
    const endDate = moment(`${date} ${to ?? pickupTimewindow[1]}`, 'YYYY-MM-DD HH:mm');
    if (to) {
      if (startDate.isAfter(endDate)) return;
    } else {
      if (startDate.isSameOrAfter(endDate)) {
        endDate.add(startDate.diff(endDate, 'minutes') + 60, 'minute');
      }
    }
    const newPickupTimeWindow: [string, string] = [startDate.format('HH:mm'), endDate.format('HH:mm')];
    setPickupTimewindow(newPickupTimeWindow);
    if (routingAttributes?.current) routingAttributes.current['pickupTimewindow'] = newPickupTimeWindow;
  };
  return (
    <Grid container flexDirection="column">
      <Slider
        value={[timeToFloat(pickupTimewindow[0]) || 9, timeToFloat(pickupTimewindow[1]) || 11]}
        min={0}
        max={24}
        step={0.25}
        marks={[
          { value: 0, label: '12am' },
          { value: 6, label: '6am' },
          { value: 7, label: '' },
          { value: 8, label: '' },
          { value: 9, label: '9am' },
          { value: 10, label: '' },
          { value: 11, label: '' },
          { value: 12, label: '12pm' },
          { value: 13, label: '' },
          { value: 14, label: '' },
          { value: 18, label: '6pm' },
          { value: 21, label: '9pm' },
          { value: 24, label: '' },
        ]}
        onChange={(_, newValue) => {
          if (Array.isArray(newValue)) {
            // Convert decimal to HH:mm
            changePickupTimewindow(floatToTime(newValue[0]), floatToTime(newValue[1]));
          }
        }}
        valueLabelDisplay="auto"
        valueLabelFormat={(val) => floatToTime(val, true)}
        disableSwap
        sx={{
          paddingTop: 4,
          marginBottom: 0,
          '& .MuiSlider-markLabel': {
            fontSize: '0.75rem',
            transform: 'translate(-10%, 0)',
            minWidth: 0,
            top: 0,
          },
        }}
      />
      <Typography variant="caption" mt={-1}>
        Pickup window:{' '}
        <span style={{ backgroundColor: '#e9d7e6ff', padding: 4, borderRadius: 5 }}>
          {floatToTime(timeToFloat(pickupTimewindow[0]), true)}
        </span>
        <span style={{ margin: '0 8px 0 8px' }}>to</span>
        <span style={{ backgroundColor: '#e9d7e6ff', padding: 4, borderRadius: 5 }}>
          {floatToTime(timeToFloat(pickupTimewindow[1]), true)}
        </span>
      </Typography>
    </Grid>
  );
}
export default React.memo(PickupTimeWindowSelector, (prevProps, nextProps) => {
  if (prevProps.routingAttributes != nextProps.routingAttributes) return false;
  if (prevProps.date != nextProps.date) return false;
  return true;
});
